const styles = {
  container: {
    margin: "14px auto"
  }
};

export default styles;
